import { TranslationMap } from '@trimble-gcs/i18n-types';

export function projectSelectDialogTranslations() {
  return {
    title: {
      text: $localize`:@@connect.projectSelectDialog.title:Select Connect Project`,
      desc: 'Title for the Connect project select dialog.',
    },
    close: {
      tooltip: {
        text: $localize`:@@connect.projectSelectDialog.close.tooltip:Close`,
        desc: 'Tooltip for the top right "X" button that closes the Connect project select dialog.',
      },
    },
    region: {
      label: {
        text: $localize`:@@connect.projectSelectDialog.region.label:Region`,
        desc: 'Label for the Connect region dropdown.',
      },
    },
    regionOptions: {
      asia: {
        text: $localize`:@@connect.projectSelectDialog.regionOptions.asia:Asia`,
        desc: "Label for 'Asia' option in the region dropdown.",
      },
      australia: {
        text: $localize`:@@connect.projectSelectDialog.regionOptions.australia:Australia`,
        desc: "Label for 'Australia' option in the region dropdown.",
      },
      europe: {
        text: $localize`:@@connect.projectSelectDialog.regionOptions.europe:Europe`,
        desc: "Label for 'Europe' option in the region dropdown.",
      },
      northAmerica: {
        text: $localize`:@@connect.projectSelectDialog.regionOptions.northAmerica:North America`,
        desc: "Label for 'North America' option in the region dropdown.",
      },
      unitedKingdom: {
        text: $localize`:@@connect.projectSelectDialog.regionOptions.unitedKingdom:United Kingdom`,
        desc: "Label for 'United Kingdom' option in the region dropdown.",
      },
    },
    cancel: {
      text: $localize`:@@connect.projectSelectDialog.cancel:Cancel`,
      desc: 'Button text to close and dismiss the Connect project select dialog.',
    },
  } satisfies TranslationMap;
}
